import type { Agent } from '@/types/agent';
import type { GlobalMetrics } from '@/types/metrics';
import type { ActivityEvent } from '@/types/event';
import { INITIAL_AGENTS } from './agents';
import { ROOMS } from './rooms';

function getRoomCenter(roomId: string): { x: number; y: number } {
  const room = ROOMS.find(r => r.id === roomId);
  if (!room) return { x: 100, y: 100 };
  return {
    x: room.pixelX + Math.round(room.pixelW / 2),
    y: room.pixelY + Math.round(room.pixelH / 2),
  };
}

export function buildInitialAgents(): Agent[] {
  return INITIAL_AGENTS.map(a => {
    const center = getRoomCenter(a.currentRoomId);
    const room = ROOMS.find(r => r.id === a.currentRoomId);
    // Place agent at first available waypoint
    const wp = room?.waypoints[0];
    const startX = wp ? wp.x : center.x;
    const startY = wp ? wp.y : center.y;
    return {
      ...a,
      pixelPath: [],
      statusDuration: 0,
      position: {
        x: startX,
        y: startY,
        facing: 'down',
      },
    };
  });
}

export const INITIAL_METRICS: GlobalMetrics = {
  totalTokensBudget: 500_000,
  tokensUsedToday: 37_200,
  totalRevenue: 5_917,
  totalMargin: 3_602,
  totalOrders: 403,
  activeTasks: 7,
  pendingValidations: 2,
  agentsOnline: 9,
  dayNumber: 47,
  tick: 0,
  revenueHistory: [4200, 4800, 5100, 4700, 5300, 5600, 5917],
  tokenHistory: [28000, 31000, 35000, 33000, 36000, 37200, 37200],
};

export const INITIAL_EVENTS: ActivityEvent[] = [
  {
    id: 'ev_001',
    type: 'sale',
    agentId: null,
    storeId: 'store_animaux',
    message: 'Nouvelle vente — Paw & Love · Mug chien personnalisé × 2 · 28,60 €',
    timestamp: Date.now() - 45000,
    read: false,
  },
  {
    id: 'ev_002',
    type: 'validation_needed',
    agentId: 'nova',
    storeId: 'store_animaux',
    message: 'NOVA demande validation — Campagne email Saint-Valentin (3 emails rédigés)',
    timestamp: Date.now() - 180000,
    read: false,
  },
  {
    id: 'ev_003',
    type: 'task_done',
    agentId: 'halo',
    storeId: 'store_animaux',
    message: 'HALO a répondu aux 3 avis négatifs — taux satisfaction estimé 80%',
    timestamp: Date.now() - 360000,
    read: true,
  },
  {
    id: 'ev_004',
    type: 'seo',
    agentId: 'cipher',
    storeId: 'store_affiches',
    message: 'CIPHER — optimisation SEO en cours · 52% · 24 fiches traitées sur 48',
    timestamp: Date.now() - 900000,
    read: true,
  },
  {
    id: 'ev_005',
    type: 'validation_needed',
    agentId: 'vector',
    storeId: 'store_famille',
    message: 'VECTOR demande validation — Listings Amazon UK/DE prêts à publier',
    timestamp: Date.now() - 1800000,
    read: false,
  },
  {
    id: 'ev_006',
    type: 'alert',
    agentId: 'prism',
    storeId: 'store_citations',
    message: 'PRISM — alerte trafic organique · Mots qui Restent · -4.2% vs hier',
    timestamp: Date.now() - 3600000,
    read: true,
  },
];
